const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuariIdActivitatsId = async (id : string, id_activitat: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id}/activitats/${id_activitat}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
